import { Component, Fragment } from 'react';
import ReactModal from '../../../../components/Modal';
import { CHECKBOX_ITEMS } from '../../../UserCancelation/config';
import SpecialOfferModal from './SpecialOfferModal';
import { sendFeedbackQuery } from './query';
import { showMessage } from '../../../../helpers/showMessage';
import Loading from '../../../../components/Loading';

class CancelationModal extends Component {
    constructor(props) {
        super(props);

        this.onChangeTextarea = this.onChangeTextarea.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.isDisabledButton = this.isDisabledButton.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.onOpenSpecialOfferModal = this.onOpenSpecialOfferModal.bind(this);
        this.onCloseSpecialOfferModal = this.onCloseSpecialOfferModal.bind(this);

        this.state = {
            feedback: [],
            textareaValue: '',
            isLoading: false,
            isOpenModal: false,
            isOpenSpecialOfferModal: false,
        };
    }

    onCloseSpecialOfferModal() {
        this.setState({
            isOpenSpecialOfferModal: false,
        });
    }

    onOpenSpecialOfferModal() {
        this.setState({
            isOpenSpecialOfferModal: true,
        });
    }

    selectAll() {
        if (this.state.allSelect) {
            this.setState({
                feedback: [],
                allSelect: false,
            });
        } else {
            this.setState({
                feedback: CHECKBOX_ITEMS,
                allSelect: true,
            });
        }
    }

    onCheck(e) {
        const value = e.target.value;
        if (this.state.feedback.includes(value)) {
            this.setState({
                feedback: this.state.feedback.filter((item) => item !== value),
                allSelect: false,
            });
        } else {
            const newItems = [...this.state.feedback, value];
            this.setState({
                feedback: newItems,
                allSelect: newItems.length === CHECKBOX_ITEMS.length,
            });
        }
    }

    onChangeTextarea(e) {
        this.setState({
            textareaValue: e.target.value,
        });
    }

    async onSubmit() {
        try {
            this.setState({
                isLoading: true,
            });

            const data = {
                reason: this.state.feedback.join(','),
                comment: this.state.textareaValue,
            };
            const response = await sendFeedbackQuery(data);
            const resData = await response.json();
            if (response.status === 400) {
                showMessage(resData?.message || 'Error sending feedback.', 'error');
            } else if (response.status === 201) {
                this.setState({
                    message: resData?.message,
                    message_tag: 'success',
                });
                this.onOpenSpecialOfferModal();
                this.props.onCloseModal();
            }
        } catch (err) {
            console.log('error', err);
            showMessage(err?.message || 'Error sending feedback.', 'error');
        } finally {
            this.setState({
                isLoading: false,
            });
        }
    }
    onCloseModal() {
        this.setState({
            isOpenModal: false,
        });
    }
    onOpenModal() {
        this.setState({
            isOpenModal: true,
        });
    }

    deleteMessage() {
        this.setState({
            message: '',
            message_tag: '',
        });
    }

    isDisabledButton() {
        if (this.state.isLoading) return true;
        if (this.state.feedback.includes(CHECKBOX_ITEMS[8]) && !this.state.textareaValue)
            return true;
        if (!this.state.textareaValue && this.state.feedback?.length === 0) return true;
        return false;
    }

    render() {
        return (
            <>
                <ReactModal
                    modalState={this.props.isOpenModal}
                    className="width-sm change-plan-cancelation-modal-wrapper"
                    onClose={this.props.onCloseModal}
                >
                    <div className="change-plan-cancelation-modal">
                        <div className="change-plan-cancelation-modal-header">
                            Help us understand why you're cancelling
                        </div>
                        <div className="change-plan-cancelation-modal-subheader">
                            Your feedback helps us improve GDdash.
                        </div>
                        <div className="change-plan-cancelation-modal-body">
                            <div className="customers-selects">
                                <div className="change-plan-cancelation-modal-body-feedback">
                                    {CHECKBOX_ITEMS?.map((item, i) => (
                                        <Fragment key={item}>
                                            <div key={item} className="customers-selects-item">
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        id={`domain-${i}`}
                                                        type="checkbox"
                                                        checked={this.state.feedback.includes(item)}
                                                        onChange={this.onCheck}
                                                        value={item}
                                                    />
                                                    <label htmlFor={`domain-${i}`}>
                                                        <span>{item}</span>{' '}
                                                    </label>
                                                </div>
                                            </div>
                                            {i === CHECKBOX_ITEMS.length - 1 &&
                                                this.state.feedback.includes(item) && (
                                                    <div className="change-plan-cancelation-modal-body-additional-field">
                                                        <label className="d-block">
                                                            Tell us more (Optional)
                                                        </label>
                                                        <div>
                                                            <textarea
                                                                placeholder="Let us know you really feel"
                                                                rows="4"
                                                                cols="40"
                                                                onChange={this.onChangeTextarea}
                                                                value={this.state.textareaValue}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                )}
                                        </Fragment>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="change-plan-cancelation-modal-footer-info">
                            <img src="/static/img/info.png" alt="icon" />
                            <div>
                                Your subscription will remain active until the end your current
                                period.
                            </div>
                        </div>
                        <div className="change-plan-cancelation-modal-footer-buttons">
                            <button
                                className="change-plan-cancelation-modal-footer-buttons-back"
                                onClick={this.props.onCloseModal}
                            >
                                Back
                            </button>
                            <button
                                className="change-plan-cancelation-modal-footer-buttons-confirm d-flex gap-8 align-items-center"
                                onClick={this.onSubmit}
                                disabled={this.state.isLoading}
                            >
                                {this.state.isLoading && <Loading onlyPreloader />}
                                Confirm cancelation
                            </button>
                        </div>
                    </div>
                </ReactModal>
                <SpecialOfferModal
                    isOpenModal={this.state.isOpenSpecialOfferModal}
                    onCloseModal={this.onCloseSpecialOfferModal}
                />
            </>
        );
    }
}

export default CancelationModal;
